import { render } from "./JobOfferWebDeveloper.vue?vue&type=template&id=0a135294&scoped=true"
import script from "./JobOfferWebDeveloper.vue?vue&type=script&lang=js"
export * from "./JobOfferWebDeveloper.vue?vue&type=script&lang=js"

import "./JobOfferWebDeveloper.vue?vue&type=style&index=0&id=0a135294&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a135294"]])

export default __exports__